var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGravityBelt = function SvgGravityBelt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18,
    r: 2,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 19a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  })));
};
export { SvgGravityBelt as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='10' cy='18' r='2' fill='%234A6067'/%3e %3ccircle cx='22' cy='18' r='2' fill='%234A6067'/%3e %3cpath d='M9 19C9 17.8954 9.89543 17 11 17H21C22.1046 17 23 17.8954 23 19H9Z' fill='%234A6067'/%3e %3c/svg%3e";